export const api_version = 1;
export const app_version = '1.1.0';
export const beta_env = false;
export const build = '2026.05.12.15.40';
export const dev_env = false;
export const staging = false;

export const server = dev_env ? 'http://lifewipe.local' : (staging ? 'https://staging.life-wipe.com' : 'https://life-wipe.com');
const stripe_dev_env = false;

export default {
    app_version: app_version,
    beta_env,
    build: build,
    dev_env: dev_env,
    facebook_app_id_nova: '1128931752630024',
    facebook_app_id_public: '2375890476168488',
    google_client_id: '389238266398-c6v3q1mauq0tle38f54c61k44jtqlohq.apps.googleusercontent.com',
    mapbox: 'pk.eyJ1IjoibGxpZmV3aXBlIiwiYSI6ImNtZnk5czlpNjBqbDgya243a2k3YnQ5b3MifQ.90xPB8sXhLAB7OytOO2dMQ',
    server: server,
    sockets: 'https://websockets.life-wipe.com',
    staging,
    stripe: stripe_dev_env ? 'pk_test_51SxWPN23WGOdDyiDIWbpFizb1fv0h6JyJL4Df2mL7EtqYy87zji3YdAOdlVCqNpQRc5DZzj4E8vE6GIEmIT9tn3800lrTdtmrH' : 'pk_live_51RGrwIP0PN0uxnyKnyLnDbPIb6P72n0ZYGI3EZ5X9rekOKlqd7ai3ecEB3SpT1S3kzxnzMVw4f1zroMzkXoRhTkq00cN8XDvfX',
    stripe_dev_env,
    use_email_2fa: false,
    version: api_version
}
